import React, { useEffect, useRef } from 'react'
import './Steam.css';
import FoxandShadowCardV2FullWebp from '../../../assets/images/FoxandShadowcardV2Full.webp';
import FoxandShadowCardV2FullPng from '../../../assets/images/FoxandShadowcardV2Full.png';
import AnimationLink from './animation_link.js';

const Steam = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { 
      threshold: 0.6,
      rootMargin: '50px'
    });

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="steam-wrapper" ref={sectionRef}>
      <div className="steam-cta-section">
        <svg 
          width="100%" 
          height="100%" 
          viewBox="0 0 1000 600" 
          preserveAspectRatio="none" 
          className="svg-viewport"
        >
          <defs>
            <mask id="steam-mask">
              <rect width="100%" height="100%" fill="black"/>
              {/* Mobile-friendly spacing - controlled by CSS classes */}
              <rect x="50" y="200" width="120" height="200" fill="white" className="rect-1 mobile-rect"/>  
              <rect x="215" y="150" width="170" height="300" fill="white" className="rect-2 mobile-rect"/>  
              <rect x="430" y="100" width="220" height="400" fill="white" className="rect-3 mobile-rect"/> 
              <rect x="695" y="150" width="170" height="300" fill="white" className="rect-4 mobile-rect"/> 
              <rect x="910" y="200" width="120" height="200" fill="white" className="rect-5 mobile-rect"/>  
            </mask>
          </defs>
        </svg>
        
        <div className="masked-image">
          <img src={FoxandShadowCardV2FullPng} alt="" />
        </div>

        <div className="steam-overlay-content">
          <div className="cta-content">
            <p>Ready to Salvage Yourself?</p>
            <div className="cta-button">
              <AnimationLink
                targetId={'wishActive_steam'}
                to={'https://store.steampowered.com/app/2134370?utm_source=web'}
                dataValue={'WISHLIST ON STEAM'}
                faIcon={'fa-brands fa-steam'}
                isExternal={true}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Steam